import { LoginUser } from '../interfaces/api';

export class User implements LoginUser {

    company_name: string;

    email: string;

    firstname: string;

    id: number;

    lastname: string;

    title: string;

    username: string;

    get name(): string {
        if (this.firstname !== undefined) {
            if (this.lastname !== undefined)
                return this.firstname + ' ' + this.lastname;
        }

        if (this.lastname !== undefined)
            return this.lastname;

        return 'Unknown';
    }

    static createFromObject(object: any) {
        let user: User = new User();
        if (object.company_name !== undefined)  user.company_name = object.company_name;
        if (object.email !== undefined)         user.email = object.email;
        if (object.firstname !== undefined)     user.firstname = object.firstname;
        if (object.id !== undefined)            user.id = object.id;
        if (object.lastname !== undefined)      user.lastname = object.lastname;
        if (object.title !== undefined)         user.title = object.title;
        if (object.username !== undefined)      user.username = object.username;
        return user;
    }
}



// WEBPACK FOOTER //
// ./src/entities/user.ts